import { render, staticRenderFns } from "./content-store-owl-carousel.vue?vue&type=template&id=06704f0c"
import script from "./content-store-owl-carousel.vue?vue&type=script&lang=js"
export * from "./content-store-owl-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports